import { gql } from '@apollo/client';
import type { FleetUser } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLFleetRequester {
  public getFleetUsers = (fleetId: string): Promise<FleetUser[]> => {
    const queryResult = graphQLRequester
      .query<{ fleetUsers: FleetUser[] }>({
        query: gql`
          query getFleetUsers($fleetId: String!) {
            fleetUsers(fleetId: $fleetId) {
              id
              active
              full_name
              language
              last_login
              email_address
              timezone_offset
              occupation
              creation_date
              fleet_id
              role
              groups_restriction
              groups {
                id
                name
                path
              }
              has_custom_permissions
              granted_permissions
            }
          }
      `,
        variables: { fleetId },
      })
      .then((response) => response.fleetUsers);

    return queryResult;
  };
}

export default GraphQLFleetRequester;
